import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../hooks/useMetaPixel';
const images = ['https://cdn.magicpatterns.com/uploads/dDSrRvtbrZ6W4cS8XUDjeL/27.png', 'https://cdn.magicpatterns.com/uploads/w3FJskxCxpAeuHnZ7M7kqC/80.png', 'https://cdn.magicpatterns.com/uploads/u5Sqzd7a5FBX7Sxrj1qgoV/81.png', 'https://cdn.magicpatterns.com/uploads/cx15qNj9RSpZCBaLqYfFfN/10.png', 'https://cdn.magicpatterns.com/uploads/n8eLDc6q1rXojFHZqkH5xS/2.png'];
export function TemplatesCarousel() {
  const allImages = [...images, ...images];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-[#0d0b14] via-slate-950 to-slate-950 relative overflow-hidden" data-id="element-206">
      <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-208">
          <h2 className="sm:text-5xl font-extrabold text-white text-[40px]" data-id="element-209">
            🎁 Exclusivo para ti: algunas de las plantillas que conseguirás{' '}
            <span className="text-pink-400" data-id="element-210">y mucho más</span>
          </h2>
        </motion.div>
      </div>

      {/* Carousel container */}
      <div className="relative w-full overflow-hidden mb-14" data-id="element-211">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-r from-slate-950 to-transparent z-10 pointer-events-none" data-id="element-212" />
        <div className="absolute right-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-l from-slate-950 to-transparent z-10 pointer-events-none" data-id="element-213" />

        {/* Sliding track */}
        <div className="flex gap-6 animate-carousel" style={{
        width: 'max-content'
      }} data-id="element-214">
          {allImages.map((src, index) => <div key={index} className="flex-shrink-0 w-64 sm:w-80 rounded-2xl overflow-hidden border border-white/10 shadow-xl shadow-black/30 bg-white/5" data-id="element-215">
              <img src={src} alt={`Plantilla ${index % images.length + 1}`} className="w-full h-auto object-cover" loading="lazy" data-id="element-216" />
            </div>)}
        </div>
      </div>

      {/* Kit image + description */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.15
    }} className="max-w-2xl mx-auto text-center px-4" data-id="element-217">
        <div className="relative inline-block" data-id="element-218">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[70%] h-[70%] bg-gradient-to-tr from-pink-500 to-purple-600 rounded-full blur-3xl opacity-30 -z-10" data-id="element-219" />
          <img src="https://cdn.magicpatterns.com/uploads/fcAQbBRNn7jqdihi6osJT9/091cdbc8-f8ed-4946-bf55-0ffac9610552_-_Editado_(1).png" alt="Kit de transformación completo" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-220" />
        </div>
        <div className="mt-6 bg-white/[0.06] backdrop-blur-sm rounded-2xl p-5 border border-white/10 inline-block" data-id="element-221">
          <p className="text-xl sm:text-2xl font-extrabold text-white leading-snug" data-id="element-222">
            KIT de transformación de mentalidad,
            <br data-id="element-223" />
            elevar ganancias y lograr metas
          </p>
          <p className="mt-2 text-pink-400 font-bold text-lg" data-id="element-224">
            +3 bonus de regalo 🎁
          </p>
        </div>

        {/* CTA Button */}
        <motion.a href="https://pay.hotmart.com/R104785188L" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('AddToCart')} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="mt-10 block w-full max-w-md mx-auto py-5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-full font-bold text-xl shadow-xl shadow-pink-500/40 hover:shadow-pink-500/60 transition-all text-center" data-id="element-225">
          ACCEDE AL KIT AHORA
        </motion.a>
      </motion.div>
    </section>;
}